import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const span = {
  large: "lg:col-span-7",
  medium: "lg:col-span-5",
  tall: "lg:col-span-5 lg:row-span-2",
  wide: "lg:col-span-7",
};

export const ProjectCard = ({ p }) => {
  const tall = p.size === "tall";
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 70 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      exit={{ opacity: 0, scale: 0.94 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`${span[p.size] || span.medium} flex`}
    >
      <Link
        to={`/work/${p.slug}`}
        data-testid={`project-card-${p.slug}`}
        className="group flex w-full flex-col overflow-hidden rounded-[28px] border border-slate-900/10 bg-white shadow-[0_12px_32px_rgba(15,23,42,0.06)] transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-2 hover:shadow-[0_30px_70px_rgba(15,23,42,0.16)]"
        style={{ "--accent": p.accent }}
      >
        <div className={`relative overflow-hidden ${tall ? "h-[320px] sm:h-[420px] lg:h-auto lg:flex-1" : "h-[280px] sm:h-[380px]"}`} style={{ background: `${p.accent}1a` }}>
          <div className="absolute inset-0 origin-bottom scale-y-0 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-y-100" style={{ background: `${p.accent}33` }} aria-hidden="true" />
          <motion.div className="absolute inset-0" initial={{ scale: 1.12 }} whileInView={{ scale: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}>
            <img src={p.cover_image} alt={`${p.title} preview`} loading="lazy" className="h-full w-full object-contain p-4 transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:-translate-y-1 group-hover:scale-[1.06] sm:p-6" />
          </motion.div>
          <span className="absolute left-4 top-4 rounded-full px-3 py-1 text-xs font-bold text-white" style={{ background: p.accent === "#FACC15" || p.accent === "#84CC16" ? "#0F172A" : p.accent }}>{p.category}</span>
          <span className="absolute bottom-4 right-4 inline-flex translate-y-4 items-center gap-1.5 rounded-full bg-slate-900 px-4 py-2 text-sm font-bold text-white opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
            View project <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
        <div className="relative flex items-start justify-between gap-4 p-6">
          <span className="absolute left-0 top-0 h-1 w-0 transition-[width] duration-700 group-hover:w-full" style={{ background: p.accent }} aria-hidden="true" />
          <div>
            <h3 className="font-display text-xl font-extrabold tracking-tight text-slate-900 sm:text-2xl">{p.title}</h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-slate-600 sm:text-base">{p.summary}</p>
          </div>
          <span className="mt-1 grid h-10 w-10 shrink-0 place-items-center rounded-full text-white transition-transform duration-500 group-hover:rotate-45" style={{ background: p.accent }}><ArrowUpRight className="h-5 w-5" /></span>
        </div>
      </Link>
    </motion.article>
  );
};
